module.exports = require("ngx-bootstrap/carousel");